import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SportsIcon from '@mui/icons-material/Sports';
import { Option } from '@components/SideBar/interfaces';
import { ROUTES } from '@routes/routes';
import { PERMISSIONS } from '@auth/permissions';

export const associationMenuOptions: Option[] = [
  {
    key: 'about',
    link: '/manage/association/about',
    icon: <InfoIcon />,
    permission: PERMISSIONS.association.about.view,
    inProduction: true,
  },
  {
    key: 'committee',
    link: ROUTES.manage.association.boardMembers,
    icon: <SupervisorAccountIcon />,
    permission: PERMISSIONS.association.boardMembers.view,
    inProduction: true,
  },
  // {
  //   key: 'forms',
  //   link: '/manage/association/forms',
  //   icon: <TextSnippetIcon />,
  // },
  {
    key: 'instructions',
    link: '/manage/association/instructions',
    icon: <MenuBookIcon />,
    permission: PERMISSIONS.association.instructions.view,
    inProduction: true,
  },
  {
    key: 'regulationsAndSafety',
    link: '/manage/association/regulations-and-safety',
    icon: <HealthAndSafetyIcon />,
    permission: PERMISSIONS.association.rulesAndRegulationsPage.view,
    inProduction: true,
  },
  {
    key: 'weaponGroups',
    link: '/manage/association/weapon-groups',
    icon: <SportsIcon />,
    permission: PERMISSIONS.association.weaponGroups.view,
    inProduction: true,
  },
];
